/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Days_Title_CountInputs */

const en_us2_profile_editors_days_title_count = /** @type {(inputs: Profile_Editors_Days_Title_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many days a week?`)
};

const pt_br2_profile_editors_days_title_count = /** @type {(inputs: Profile_Editors_Days_Title_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos dias por semana?`)
};

const es_419_profile_editors_days_title_count = /** @type {(inputs: Profile_Editors_Days_Title_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuántos días por semana?`)
};

const pt_pt2_profile_editors_days_title_count = /** @type {(inputs: Profile_Editors_Days_Title_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos dias por semana?`)
};

const fr_fr2_profile_editors_days_title_count = /** @type {(inputs: Profile_Editors_Days_Title_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de jours par semaine ?`)
};

const de_de2_profile_editors_days_title_count = /** @type {(inputs: Profile_Editors_Days_Title_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viele Tage pro Woche?`)
};

const it_it2_profile_editors_days_title_count = /** @type {(inputs: Profile_Editors_Days_Title_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanti giorni a settimana?`)
};

/**
* | output |
* | --- |
* | "How many days a week?" |
*
* @param {Profile_Editors_Days_Title_CountInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_days_title_count = /** @type {((inputs?: Profile_Editors_Days_Title_CountInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Days_Title_CountInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_days_title_count(inputs)
	if (locale === "es-419") return es_419_profile_editors_days_title_count(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_days_title_count(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_days_title_count(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_days_title_count(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_days_title_count(inputs)
	return en_us2_profile_editors_days_title_count(inputs)
});
export { profile_editors_days_title_count as "profile-editors.days_title_count" }